// Key labels differ by platform, and showing the wrong ones is worse than showing none: an admin on
// Windows reading ⌘Z has no way to know it means Ctrl+Z.
//
// The bindings themselves are already cross-platform — `gridKeyAction` accepts `ctrlKey` wherever it
// accepts `metaKey`, so Ctrl+Z, Ctrl+Shift+Z and Ctrl+Enter work as they should. This is only about
// what the legend says.
export interface KeyLabels {
  mod: string;
  alt: string;
  shift: string;
  enter: string;
  del: string;
}

// A pure function of the platform string so both branches can be tested; the detection itself is
// the only part that has to run in a browser.
export function keyLabels(platform: string): KeyLabels {
  const apple = /mac|iphone|ipad|ipod/i.test(platform);
  return apple
    ? { mod: '⌘', alt: '⌥', shift: '⇧', enter: '↵', del: '⌫' }
    : { mod: 'Ctrl', alt: 'Alt', shift: 'Shift', enter: 'Enter', del: 'Backspace' };
}

function detect(): string {
  if (typeof navigator === 'undefined') return '';
  // userAgentData.platform is the supported route in Chromium; navigator.platform is deprecated but
  // still the only thing Safari and Firefox offer.
  const data = (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData;
  return data?.platform ?? navigator.platform ?? '';
}

export const KEYS = keyLabels(detect());
